import { camelCase } from 'lodash';

import type { Playbook, PlaybookTask } from './types';

export const isDealPlaybook = (playbook: Playbook): boolean => {
  return ('dealType' in playbook) && ('tasksByStage' in playbook);
};

export const isListingPlaybook = (playbook: Playbook): boolean => {
  return ('listingType' in playbook) && ('tasksByStatus' in playbook);
};

export const getPlaybookType = (playbook: Playbook): string => {
  return ('dealType' in playbook) ? playbook.dealType : playbook.listingType;
};

export const getPlaybookTasks = (playbook: Playbook): Record<string, PlaybookTask[]> => {
  return ('tasksByStage' in playbook) ? playbook.tasksByStage : playbook.tasksByStatus;
};

export const getPlaybookRecordType = (playbook: Playbook): 'deal' | 'listing' => {
  return isDealPlaybook(playbook) ? 'deal' : 'listing';
};

export const getStageOrStatus = (playbook: Playbook, task: PlaybookTask): string => {
  return isDealPlaybook(playbook) ? task.stage : camelCase(task.status);
};

export const getPlaybookTasksForTarget = (playbook: Playbook, task: PlaybookTask): PlaybookTask[] => {
  const tasks = getPlaybookTasks(playbook);
  const key = getStageOrStatus(playbook, task);

  return tasks[key];
};
